import { Link } from "react-router-dom";
import RedFlag from "../Icon/RedFlag/RedFlag";
import "./Logo.css";

export default function Logo() {
  return (
    <div className="site-logo">
      <Link to="/">
        <RedFlag size="1.5em" /> Red Flag
      </Link>
    </div>
  );
}
